(function ($) {

  Drupal.behaviors.THEMEOwlConfig = {
    attach: function (context, settings) {
      $(".owl-carousel").owlCarousel({
        center: true,
        margin: 1000,
        autoWidth: false,
        items:1,
        dots: false,
        nav: true,
        navText:['<i data-wtf class="icon--chevron-left slick-arrow owl--prev" aria-disabled="false" style="display: inline;"></i>','<i data-wtf class="icon--chevron-right slick-arrow owl--next" style="" aria-disabled="false"></i>' ],
        loop:true,
        URLhashListener:true,
        autoplayHoverPause:true,
        startPosition: 'URLHash'
      });
    }
  };

})(jQuery);
